import { Component } from 'react';
import PropTypes from 'prop-types';
import assign from 'lodash/assign';
import get from 'lodash/get';

import NewsletterModel from '../../../models/newsletter_module';
import sendGASubscriptionEvents from '../../../utils/newsletter_ga_util';

// let scriptjs;

class NewsletterSubscriber extends Component {
  constructor(props) {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleEmailUpdate = this.handleEmailUpdate.bind(this);
    this.handleVerify = this.handleVerify.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);

    this.statusMessages = {
      normal: "You're subscribed",
      error: 'There was an error.',
      loading: 'Loading'
    };

    const config = get(props, 'config');
    const allNewsletterData = get(config, 'newsletters.listsBySlug');
    const newslettersState = {};
    const newsletterIds = props.newsletterIds || [];
    props.newsletters.forEach(function mapPropsToState(newsletterObj) {
      const listPropName = get(newsletterObj, 'list');
      const listId = get(allNewsletterData, listPropName);

      newslettersState[listId] = !!newsletterObj.default;
    });

    // hack until i refactor this
    newsletterIds.forEach(function mapPropsToState(id) {
      newslettersState[id] = false;
    });
    this.state = {
      email: '',
      newsletters: newslettersState,
      shouldDisplayReCaptcha: false
    };
  }

  handleInputFocus() {
    if (!this.state.shouldDisplayReCaptcha) {
      this.setState({
        shouldDisplayReCaptcha: true
      });
    }
  }

  handleUpdate(e) {
    const { target } = e;
    const { value, name } = target;
    const newNewsletterState = assign({}, this.state.newsletters, {
      [name]: value
    });

    this.setState({
      newsletters: newNewsletterState
    });
  }

  handleEmailUpdate(e) {
    const { target } = e;
    const { value } = target;
    this.setState({
      email: value
    });
  }

  handleVerify(value) {
    this.setState({ recaptcha: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    const savedEmail = this.state.email;
    this.setState(
      { disabled: true, status: 'loading', email: '' }, // eslint-disable-line react/no-unused-state
      function disbaledSetStateCallback() {
        const newsletters = Object.keys(this.state.newsletters) || [];
        const selectedNewsletters = newsletters.filter(
          function filterNewsletterList(listId) {
            return this.state.newsletters[listId];
          }.bind(this)
        );
        const currUrl = get(this.props.config, 'navHistory[0]');
        const data = {
          email: savedEmail,
          lists: selectedNewsletters,
          sourceDescription: currUrl,
          recaptcha: this.state.recaptcha
        };
        new NewsletterModel()
          .post(data, this.props.config)
          .then(
            function receiveResponse(response) {
              sendGASubscriptionEvents(
                data.lists,
                this.props.config.newsletters
              );
              this.setState({
                disabled: false, // eslint-disable-line react/no-unused-state
                status: get(response, 'data.[0].status', '').toLowerCase() // eslint-disable-line react/no-unused-state
              });
            }.bind(this)
          )
          .catch(
            function handleUserError() {
              // change this to err.status after 400 issue is fixed
              this.setState({ disabled: false, status: 'error', error: true }); // eslint-disable-line react/no-unused-state
            }.bind(this)
          );
      }.bind(this)
    );
  }
}

NewsletterSubscriber.defaultProps = {
  newsletters: [],
  newsletterIds: []
};

NewsletterSubscriber.propTypes = {
  newsletters: PropTypes.arrayOf(PropTypes.shape({})),
  newsletterIds: PropTypes.arrayOf(PropTypes.number),
  config: PropTypes.shape({
    newsletters: PropTypes.shape({}).isRequired
  }).isRequired
};

export default NewsletterSubscriber;
